<div class="row my-5">
    <div class="col-sm-12">
      <app-grid-demo></app-grid-demo>
   
          <ng-container *ngIf="post$ | async as post">
              <div id="pitch-post"  markdown [src]="post"></div>
          </ng-container>
       
      <app-free-download></app-free-download>
        
  </div>
  </div>
